export default [
    {
        header: 'Component(Sidebar):system',
        action: 'see',
        resource: 'system-section',
    },
    {
        title: 'Component(Sidebar):administration-subscribers',
        icon: 'BriefcaseIcon',
        activeForRoutes: ['administration-subscribers-add', 'administration-subscribers-edit'],
        route: 'administration-subscribers',
        action: 'visit',
        resource: 'administration-subscribers',
    },
    {
        title: 'Regulation management',
        icon: 'BriefcaseIcon',
        route: null,
        children: [
            {
                title: 'Component(Sidebar):administration-legislations',
                activeForRoutes: ['administration-legislations-add', 'administration-legislations-edit'],
                route: 'administration-legislations',
                action: 'visit',
                resource: 'administration-legislations',
            },
            {
                title: 'Questions',
                activeForRoutes: [
                    'administration-legislation-question-group-create',
                    'administration-legislation-question-group-card',
                ],
                route: 'administration-legislation-question-groups',
                action: 'visit',
                resource: 'administration-legislation-question-groups',
            },
        ],
    },
    {
        title: 'Component(Sidebar):administration-product',
        icon: 'FileTextIcon',
        route: null,
        children: [
            {
                title: 'Component(Sidebar):administration-product-general-product-statements',
                route: 'administration-product-general-product-statements',
                action: 'visit',
                activeForRoutes: ['administration-product-general-product-statements-add', 'administration-product-general-product-statements-edit'],
                resource: 'administration-product-general-product-statements',
            },
        ]
    },
    {
        title: 'Component(Sidebar):administration-substances',
        icon: 'FileTextIcon',
        route: null,
        children: [
            {
                title: 'Component(Sidebar):administration-substances-regulated substances',
                route: 'administration-substances-regulated-substances',
                action: 'visit',
                activeForRoutes: ['administration-substances-regulated-substances-edit'],
                resource: 'administration-substances-regulated-substances',
            },
        ]
    },
    {
        title: 'Component(Sidebar):administration-pages',
        icon: 'LayoutIcon',
        route: null,
        children: [
            {
                title: 'Component(Sidebar):administration-pages-system-articles',
                route: 'administration-pages-system-articles',
                action: 'visit',
                activeForRoutes: ['administration-pages-system-articles-edit'],
                resource: 'administration-pages-system-articles',
            },
            {
                title: 'Component(Sidebar):administration-pages-news',
                route: 'administration-pages-news',
                action: 'visit',
                activeForRoutes: ['administration-pages-news-add', 'administration-pages-news-edit'],
                resource: 'administration-pages-news',
            },
            {
                title: 'Component(Sidebar):administration-pages-categories',
                route: 'administration-pages-categories',
                activeForRoutes: ['administration-pages-categories-add', 'administration-pages-categories-edit'],
                action: 'visit',
                resource: 'administration-pages-categories',
            },
        ]
    },

    {
        title: 'Component(Sidebar):administration-import',
        icon: 'DownloadIcon',
        route: null,
        children: [
            {
                title: 'Component(Sidebar):administration-import-echa-candidate-list',
                route: 'administration-import-candidate-list',
                action: 'visit',
                resource: 'administration-import-candidate-list',
            },
            {
                title: 'Component(Sidebar):administration-import-suppliers',
                route: 'administration-import-suppliers',
                action: 'visit',
                resource: 'administration-import-suppliers',
            },
        ]
    },

    {
        title: 'Component(Sidebar):translations',
        route: 'system-translations',
        icon: 'TypeIcon',
        action: 'visit',
        resource: 'system-translations',
    },
    {
        title: 'Component(Sidebar):system-security',
        icon: 'ShieldOffIcon',
        route: null,
        children: [
            {
                title: 'Component(Sidebar):system-security-user-roles',
                route: 'system-security-user-roles',
                action: 'visit',
                resource: 'system-security-user-roles',
            },
            {
                title: 'Component(Sidebar):system-service',
                route: 'system-services',
                activeForRoutes: ['system-services-create', 'system-services-card'],
                action: 'visit',
                resource: 'system-services',
            },
            {
                title: 'Component(Sidebar):system-security-user-interface',
                route: 'system-security-user-interface',
                activeForRoutes: ['system-security-user-interface-card'],
                action: 'visit',
                resource: 'system-security-user-interface',
            },
            {
                title: 'Component(Sidebar):system-security-operations',
                route: 'system-security-operations',
                action: 'visit',
                resource: 'system-security-operations',
            },
        ]
    },
    {
        title: 'Scheduler',
        route: 'system-scheduler-tasks',
        icon: 'CalendarIcon',
        action: 'visit',
        resource: 'system-scheduler-tasks',
    },
];
